import { makeApi, URLS } from "Utils/apiURL";

class GeminiService {
  async chat(userMessage) {
    const config = {
      url: URLS.aiChat,
      method: "POST",
      data: {
        message: userMessage
      }
    };

    try {
      const response = await makeApi(config);

      if (response && response.status === 200 && response.data) {
        // Backend should return the answer, preferably in { answer: "..." } format
        // or just the raw string. We handle both.
        const { answer, text, response: aiResponse } = response.data;
        return answer || text || aiResponse || (typeof response.data === 'string' ? response.data : "I received a response but couldn't parse it.");
      } else {
        throw new Error(response.data?.error || "Failed to reach AI Backend");
      }

    } catch (error) {
      console.error("AI Backend Error Details:", error);

      let errorMessage = "Unable to connect to AI Service. Please try again later.";

      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error("Data:", error.response.data);
        console.error("Status:", error.response.status);
        console.error("Headers:", error.response.headers);

        if (error.response.status === 404) {
          errorMessage = "AI Service endpoint not found (404). Please ensure the backend is running and the URL is correct.";
        } else if (error.response.status === 500) {
          errorMessage = "AI Service encountered an internal error (500). Please check backend logs.";
        } else if (error.response.data && error.response.data.error) {
          errorMessage = `AI Service Error: ${error.response.data.error}`;
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.error("No response received:", error.request);
        errorMessage = "No response from AI Service. Is the backend server running?";
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error setting up request:", error.message);
        errorMessage = `Request Error: ${error.message}`;
      }

      throw new Error(errorMessage);
    }
  }

  // Deprecated but kept for compatibility during transition
  setApiKey(key) { console.log("API Key management is now handled by backend."); }
  getApiKey() { return "BACKEND_MANAGED"; }
}

export default new GeminiService();
